export class TokenDetails {
  token!: string;
}

export class DisplayHtmlContentCommonModel {
  title!: string;
  content!: string;
  closeButtonText: string = "Close";
}
